import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-astcivilengineering',
  templateUrl: './astcivilengineering.component.html',
  styleUrls: ['./astcivilengineering.component.scss']
})
export class AstcivilengineeringComponent implements OnInit {

  constructor() { }

    ngOnInit(): void {
        window.scrollTo(0, 0);
    }

}
